/*
 *
 * CheckRefundableTransactionModal
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 02-Jul-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantModal from '@nexidigital/merchantmodal'
import formattedMessage from './languageModule'
import { CallConnecting } from '@nexidigital/iconlibrary'
import { Capacitor } from '@capacitor/core'

const CheckRefundableTransactionModal = (props) => {
  const isAdminISP = props.userRole === 'ADMIN' || null
  const supportNumber = '800303303'

  return (
    <Toggle>
      <MerchantModal
        title={isAdminISP ? formattedMessage.titleModalNotReversibleMixed : formattedMessage.titleModalNotReversible}
        description={isAdminISP ? formattedMessage.descriptionModalNotReversibleMixed : formattedMessage.descriptionModalNotReversible}
        onClose={() => { props.actions.doHidePopup() }}
        primaryButtonLabel={formattedMessage.labelPrimaryButtonModalNotReversible}
        primaryAction={() => { props.actions.doHidePopup() }}
        secondaryButtonLabel={Capacitor.isNativePlatform() ? formattedMessage.labelSecondaryButtonModalNotReversibleMixed : null}
        secondaryAction={Capacitor.isNativePlatform()
          ? () => {
              window.location.href = `tel:${supportNumber}`
            }
          : null}
        secondaryIcon={Capacitor.isNativePlatform() ? <CallConnecting size='20' type='line' /> : null}
      />
    </Toggle>
  )
}

CheckRefundableTransactionModal.propTypes = {
  actions: PropTypes.object,
  userRole: PropTypes.string
}

CheckRefundableTransactionModal.defaultProps = {
  actions: {},
  userRole: ''
}

export default CheckRefundableTransactionModal
